import React from 'react';
import { Container, Row, Col, Button, Image } from 'react-bootstrap';
import logo from '../assets/images/favicon-32x32.png'; // Putanja do vašeg logotipa
import ContactInfo from '../components/shared/ContactInfo';
import Footer from '../components/Footer';
import { useTranslation } from 'react-i18next';


const HomePage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="bg-light min-vh-100 d-flex align-items-center rounded-4">
      <Container>
        <Row className="justify-content-center text-center">
          <Col lg={8}>
            <Image src={logo} alt="Logo aplikacije" className="mb-4" />
            <h1 className="display-4 fw-bold mb-4">
              {t('text.headline.freeApp')}
            </h1>
            <p className="lead mb-4">
            {t('text.simpleInvoiceCreation')}
            </p>
            <Button
              variant="primary"
              size="lg"
              className="px-5 py-3 mb-4"
              href="/create"
            >
            {t('startNow')}
            </Button>
          </Col>
        </Row>
        <ContactInfo></ContactInfo>
        <Footer isDefault={true}></Footer>
      </Container>
    </div>
  );
};

export default HomePage;
